import { composeIO } from 'react-compose-io'
import { itemParceiroIO } from './ItemParceiro.IO'
import { ItemParceiroView } from './ItemParceiro.View'

export const ItemParceiro = composeIO(ItemParceiroView, itemParceiroIO)
